<template>
  <div class="d-flex">
    <div class="cards">
      <div>
        <h1>My Wallet</h1>

        <!-- Visa - selectable -->
        <div class="credit-card visa selectable">
          <div class="credit-card-last4">4242</div>
          <div class="credit-card-expiry">08/25</div>
        </div>

        <!-- Mastercard - selectable -->
        <div class="credit-card mastercard selectable">
          <div class="credit-card-last4">8210</div>
          <div class="credit-card-expiry">10/22</div>
        </div>

        <div class="credit-card new">
          <span class="add">+</span>
        </div>
      </div>
    </div>
    <div class="txns">
      <h1>Balance</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Wallet"
};
</script>

<style>
@import "../../assets/card.scss";
</style>
